<div class="body gray">
  <main class="min-h-screen flex flex-column relative flex-auto main">
    <!--Header-->
    <au-public-header></au-public-header>

    <div class="router-container">
      <router-outlet></router-outlet>
    </div>
    <!--Footer-->
    <au-public-footer></au-public-footer>
  </main>
</div>
